'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacers.XS}rem;
  color: ${({ theme }) => theme.colors.typographyBodyLight};
`;

export const AdressText = styled.p`
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  color: ${({ theme }) => theme.colors.actionDefault};
  font-weight: ${(props) => props.theme.typography.title.fontWeight};
  line-height: ${(props) => props.theme.typography.title.lineHeight};
`;
